import { type GridInputSelectionModel, type GridCallbackDetails, type GridSelectionModel } from '@mui/x-data-grid-pro';
import { type DbAbonent } from '@/shared/api/orval/models';

export interface OsiPastInvoicesViewModel {
  abonents: DbAbonent[];
  selectionModel: GridInputSelectionModel;
  date: Date;
  isLoading: boolean;
  abonentsIsNotSelected: boolean;
  // OSI-845: галочка «Отдельными квитанциями» (по умолчанию false)
  isSeparateFiles: boolean;

  onSelectionModelChange: (selectionModel: GridSelectionModel, details: GridCallbackDetails) => void;
  // OSI-845: переключение галочки «Отдельными квитанциями»
  setIsSeparateFiles: (value: boolean) => void;
  downloadInvoices: () => Promise<void>;
}

export const OsiPastInvoicesViewModelIdentifier = Symbol.for('OsiPastInvoicesViewModel');
